import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../../services/employee.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AnalyticsService } from '../../services/analytics.service';
import { menurolesService } from '../../services/menuroles.service';


@Component({
  selector: 'app-staff-list',
  templateUrl: './staff-list.component.html',
  styleUrls: ['./staff-list.component.scss']
})
export class StaffListComponent implements OnInit {
  isPageEditable: boolean = false;
  selectedview: number;
  employees: Observable<any>;
  employee: any;
  statusMessage: string = "Loading data please wait...";
  public isSlide: boolean = false;
  constructor(private _employeeService: EmployeeService, private router: Router, private _analyticsService: AnalyticsService, private _menurolesService: menurolesService) {

    this.selectedview = 0;
  }
  ngOnInit() {
    const $ = window["$"];
    function toggleIcon(e) {
      $(e.target)
        .prev('.panel-heading')
        .find(".more-less")
        .toggleClass('glyphicon-plus glyphicon-minus');
    }
    $('.panel-group').on('hidden.bs.collapse', toggleIcon);
    $('.panel-group').on('shown.bs.collapse', toggleIcon);
    this.getStaffList();
    this.isPageEditable = this._menurolesService.getpageAcessbility()
  }

  selectName(event) {
    this.selectedview = event;
  }
  getEmployeeProfile(empid) {

    this.router.navigate(['/employeeProfile']);
  }

  redirctEditpage(emp) {
    var empdetils = this.getEmpleeProfile(emp);

  }

  getEmpleeProfile(data) {
    this._employeeService.getStaffdetails(data)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            // this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.employee = employeeData.response.doctotdetails;
            this._employeeService.setEmpleeData(this.employee);
            this.router.navigate(['/EditStaff']);
          }
          console.log(this.employee);
        },
        (error) => {
          // this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );

  }

  onSearchChange(searchValue: string) {
    this._analyticsService.searchDoctors(searchValue, 3)
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.employees = employeeData.response.doctotList
          }
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }
      );
  }

  getStaffList() {
    this._employeeService.getStaff()
      .subscribe(
        (employeeData) => {
          if (employeeData == null) {
            this.statusMessage = "Employee Id does not exist..";
          }
          else {
            this.employees = employeeData.response.staffList
          }
          console.log(this.employees);
        },
        (error) => {
          this.statusMessage = "Problem with the service. Please try again after sometime";
          console.log(error);
        }

      );
  }



  verifyEmployee(emp) {
    let confimationMessage = emp.isVerified == true ? "Are you sure want to UnApprove " + emp.name : "Are you sure want to Approve " + emp.name;
    if (confirm(confimationMessage)) {
      console.log("Implement delete functionality here");
      this._employeeService.verifyEmployee(emp).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record updated sucessfully")
            this.getStaffList();
          }
          else {
            alert(data.returnMsg)
          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });

    }
    else {
      this.getStaffList();
    }

  }

  deleteEmployee(emp) {
    let confimationMessage = "Are you sure want to Delete " + emp.name;
    if (confirm(confimationMessage)) {
      console.log("Implement delete functionality here");
      this._employeeService.deleteEmployee(emp).subscribe(
        data => {
          if (data.returnCode == 0) {
            alert("Record Deleted sucessfully")
            this.getStaffList();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });

    }
  }


  sideBarToggle() {
    if (this.isSlide) {
      this.isSlide = false;
    }
    else {
      this.isSlide = true;
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/admin/staff-list/staff-list.component.ts